import { axiosInstance } from "@dexteel/mesf-core";
import nProgress from "nprogress";
import "nprogress/nprogress.css";
import "./custom-nprogress.css";
let numberOfAjaxCAllPending = 0;
nProgress.configure({ showSpinner: true });

// Request
axiosInstance.interceptors.request.use(
	function (config) {
		numberOfAjaxCAllPending++;
		// Start the nprogress bar
		nProgress.start();
		return config;
	},
	function (error) {
		nProgress.done();
		console.error(error);
		return Promise.reject(error);
	},
);

// Response
axiosInstance.interceptors.response.use(
	function (response) {
		numberOfAjaxCAllPending--;
		if (numberOfAjaxCAllPending == 0) {
			// End the nprogress bar
			nProgress.done();
		}
		return response;
	},
	function (error) {
		numberOfAjaxCAllPending--;
		if (numberOfAjaxCAllPending == 0) {
			nProgress.done();
		}
		console.error("error", error);
		return Promise.reject(error);
	},
);
